<template>
    <div class="forex-index">
        <page-navigate></page-navigate>

        <div class="forex-wrapper cn">
            <forexMenu />
            <div class="forex-wrapper-body">

                <div id="search-box-index">
                    <div class="ebc-tabs no-scrollbar">
                        <a href="javascript:;" class="ebc-tab-line-item ebc-tab-line-item-selected">
                            MT4
                        </a>
                        <a href="/jinrong/mt5/" class="ebc-tab-line-item">
                            MT5
                        </a>
                        <a href="/jinrong/trading-central/" class="ebc-tab-line-item">
                            Trading Central
                        </a>
                        <a href="/jinrong/trading-view/" class="ebc-tab-line-item">
                            Trading View
                        </a>
                    </div>
                </div>
                <h1 class="">MetaTrader 4</h1>
                <div class="forex-title-intro">
                    MetaTrader
                    4（MT4）于2005年由Metaquotes开发，是一个交易平台，被交易者和经纪人广泛使用。这是一个高级交易平台，可以在桌面或移动设备上下载和安装。MT4平台向贸易商提供了一个灵活的交易系统，该交易系统带有市场分析工具和可自定义图表。它的实力在于它与专家顾问（EAS）进行算法自动化的潜力，使交易者能够以更高的精确和效率设计和实施其交易策略。
                </div>
                <section class="section1">
                    <div class="download-list">
                        <div>
                            <h3>桌面版下载</h3>
                            <div class="download-group">
                                <a rel="nofollow" target="_blank"
                                    href="https://download.terminal.free/cdn/web/23057/mt4/ebcfinancialgroupky4setup.exe"
                                    class="download-item">
                                    <img src="../../assets/image/forex/tools/window.png?v=1.0.1"
                                        class="download-item-img" alt="" />
                                    <p class="download-item-name">
                                        Windows <span class="iconfont icon-download"></span>
                                    </p>
                                </a>
                                <a rel="nofollow" target="_blank"
                                    href="https://download.mql5.com/cdn/web/metaquotes.software.corp/mt4/MetaTrader4.pkg.zip"
                                    class="download-item">
                                    <img src="../../assets/image/forex/tools/mac.png?v=1.0.1" class="download-item-img"
                                        alt="" />
                                    <p class="download-item-name">
                                        MacOS <span class="iconfont icon-download"></span>
                                    </p>
                                </a>
                                <a rel="nofollow" target="_blank" href="/MetaTraderWeb.html?lang=cn" class="download-item">
                                    <img src="../../assets/image/forex/tools/web.png?v=1.0.1" class="download-item-img"
                                        alt="" />
                                    <p class="download-item-name">
                                        Web <span class="iconfont icon-redirect"></span>
                                    </p>
                                </a>
                            </div>
                        </div>
                        <div>
                            <h3>移动端下载</h3>
                            <div class="download-group">
                                <a rel="nofollow" target="_blank"
                                    href="https://download.mql5.com/cdn/mobile/mt4/ios?server=EBCFinancialGroupKY-Live"
                                    class="download-item">
                                    <img src="../../assets/image/forex/tools/ios.png?v=1.0.1" class="download-item-img"
                                        alt="" />
                                    <p class="download-item-name">
                                        ios <span class="iconfont icon-download"></span>
                                    </p>
                                </a>
                                <a rel="nofollow" target="_blank" href="https://appgallery.huawei.com/#/app/C102015319"
                                    class="download-item">
                                    <img src="../../assets/image/forex/tools/huawei.png?v=1.0.1"
                                        class="download-item-img" alt="" />
                                    <p class="download-item-name">
                                        huawei <span class="iconfont icon-download"></span>
                                    </p>
                                </a>
                                <a rel="nofollow" target="_blank"
                                    href="https://download.mql5.com/cdn/mobile/mt4/android?server=EBCFinancialGroupKY-Live"
                                    class="download-item">
                                    <img src="../../assets/image/forex/tools/and.png?v=1.0.1" class="download-item-img"
                                        alt="" />
                                    <p class="download-item-name">
                                        Android <span class="iconfont icon-download"></span>
                                    </p>
                                </a>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="section2">
                    <h2 class="">MT4基础教程</h2>
                    <div class="swiper document-list-wrapper1">
                        <swiper ref="swiperBasic" :options="swiperBasicOptions" class="document-list">
                            <swiper-slide v-for="vo in basicList" :id="vo.id">
                                <div class="document-item">
                                    <a :href="vo.url.replace('/zh-cn', '')" class="document-item-img-box">
                                        <img class="document-item-img" :src="vo.thumbnail" :alt="vo.post_title" />
                                    </a>
                                    <div>
                                        <a :href="vo.url.replace('/zh-cn', '')" class="document-item-title">{{
                                            vo.post_title }}</a>
                                        <div class="document-btn-text">
                                            {{ formateTime(vo.published_time) }}
                                        </div>
                                    </div>
                                </div>
                            </swiper-slide>
                        </swiper>
                    </div>
                </section>
                <section class="section3">
                    <h2 class="">MT4进阶教程</h2>

                    <div class="swiper document-list-wrapper2">
                        <swiper ref="swiperAdvanced" :options="swiperAdvancedOptions" class="document-list">
                            <swiper-slide v-for="vo in advancedList" :key="vo.id">
                                <div class="document-item">
                                    <a :href="vo.url.replace('/zh-cn', '')" class="document-item-img-box">
                                        <img class="document-item-img" :src="vo.thumbnail" :alt="vo.post_title" />
                                    </a>
                                    <div>
                                        <a :href="vo.url.replace('/zh-cn', '')" class="document-item-title">{{
                                            vo.post_title }}</a>
                                        <div class="document-btn-text">
                                            {{ formateTime(vo.published_time) }}
                                        </div>
                                    </div>
                                </div>
                            </swiper-slide>
                        </swiper>
                    </div>
                </section>
                <section class="section4">
                    <h2 class="">MT4相关问题</h2>
                    <div class="QA-list">
                        <div class="QA-item">
                            <div class="QA-title">
                                1. MT4是什么？适合外汇新手交易者使用吗？
                            </div>
                            <div class="QA-content">
                                <p class="QA-li">
                                    MetaTrader 4（简称 MT4）是由 MetaQuotes
                                    开发的专业外汇交易平台，提供图表分析、自动交易、EA策略支持等功能。对于新手来说，MT4拥有简洁的操作界面和广泛的教程支持，是入门外汇交易的首选平台之一。
                                </p>
                            </div>
                        </div>
                        <div class="QA-item">
                            <div class="QA-title">
                                2. 如何在MT4上安装和使用EA（智能交易系统）？
                            </div>
                            <div class="QA-content">
                                <p class="QA-li">
                                    安装EA非常简单：在MT4中打开“文件” > “打开数据文件夹” >
                                    将EA文件放入 Experts
                                    文件夹中，重启MT4即可在导航栏看到EA。将EA拖入图表后，确保启用“自动交易”按钮即可运行策略。
                                </p>
                            </div>
                        </div>

                        <div class="QA-item">
                            <div class="QA-title">
                                3. MT4支持哪些交易品种？可以交易黄金、原油和指数吗？
                            </div>
                            <div class="QA-content">
                                <p class="QA-li">
                                    MT4支持包括外汇、黄金、原油、股指等多种金融产品。具体可交易品种取决于您所在平台或经纪商所提供的账户类型和合约设置。
                                </p>
                            </div>
                        </div>
                        <div class="QA-item">
                            <div class="QA-title">
                                4. 如何在MT4中添加自定义技术指标和图表模板？
                            </div>
                            <div class="QA-content">
                                <p class="QA-li">
                                    您可以下载自定义指标（.ex4 或 .mq4 文件）并放入 MT4 的
                                    Indicators
                                    文件夹，重启软件即可加载。在图表上右键选择“模板”功能，可保存/载入您喜欢的图表样式和设置，提升交易效率。
                                </p>
                            </div>
                        </div>
                        <div class="QA-item">
                            <div class="QA-title">
                                5. MT4手机版和电脑版有什么区别？如何同步账户？
                            </div>
                            <div class="QA-content">
                                <p class="QA-li">
                                    MT4电脑版功能更完整，支持EA自动交易与更多图表功能；手机版适合随时随地查看行情和执行交易。两者通过登录相同的账号和服务器，即可同步交易账户信息与余额。
                                </p>
                            </div>
                        </div>
                        <div class="QA-item">
                            <div class="QA-title">
                                6. MT4出现“无连接”或挂单失败怎么办？常见错误如何排查？
                            </div>
                            <div class="QA-content">
                                <p class="QA-li">
                                    常见原因包括网络问题、服务器选择错误、账户未激活或杠杆不足。建议检查是否正确选择了服务器地址、确保网络通畅、账户资金充足，并联系平台客服获得技术支持。
                                </p>
                            </div>
                        </div>
                    </div>
                </section>

            </div>
        </div>

        <page-footer></page-footer>
    </div>
</template>
<script>
import moment from 'moment';
import forexMenu from '../../components/forex-menu/forex-menu.vue';
import { getMT4Tutorial } from '../../serve/forex.js';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'

export default {
    components: {
        forexMenu,
        Swiper, SwiperSlide
    },
    data() {
        return {
            basicList: [],
            advancedList: [],
            swiperBasicOptions: {
                slidesPerView: 1.1,
                spaceBetween: 15,
                observer: true,
                observeParents: true,

                breakpoints: {
                    // 当容器宽度 <= 996px 时
                    0: {
                        // 这里定义了最小断点，覆盖所有小尺寸
                        slidesPerView: 1.1,
                        spaceBetween: 15,
                    },
                    997: {
                        // 当容器宽度 >= 997px 时恢复默认设置
                        slidesPerView: 3,
                        spaceBetween: 15,
                    },
                },
            },
            swiperAdvancedOptions: {
                slidesPerView: 1.1,
                spaceBetween: 15,
                observer: true,
                observeParents: true,

                breakpoints: {
                    // 当容器宽度 <= 996px 时
                    0: {
                        // 这里定义了最小断点，覆盖所有小尺寸
                        slidesPerView: 1.1,
                        spaceBetween: 15,
                    },
                    997: {
                        // 当容器宽度 >= 997px 时恢复默认设置
                        slidesPerView: 3,
                        spaceBetween: 15,
                    },
                },
            },
        }
    },
    created() {
        getMT4Tutorial().then(response => {
            if (response.status && response.status == '200') {
                this.basicList = response.data.data.basic
                this.advancedList = response.data.data.advanced
            }

        }).catch(err => {
            this.basicList = []
            this.advancedList = []
        })
    },
    mounted() {
         // 获取所有的QA-item元素
            var qaItems = document.querySelectorAll(".QA-item");

            // 遍历每个QA-item，为其添加点击事件监听器
            qaItems.forEach(function (item) {
                item.addEventListener("click", function () {
                    // 获取当前点击的QA-content元素
                    var content = this.querySelector(".QA-content");

                    // 如果点击的QA-content是隐藏的，则展示它；反之则隐藏
                    if (content.style.display === "none" || content.style.display === "") {
                        // 移除所有其他QA-item上的.QA-actived类，并隐藏其QA-content
                        qaItems.forEach(function (otherItem) {
                            otherItem.querySelector(".QA-content").style.display = "none";
                            otherItem.classList.remove("QA-actived");
                        });

                        // 展示当前点击的QA-content，并为当前QA-item添加.QA-actived类
                        content.style.display = "block";
                        this.classList.add("QA-actived");
                    } else {
                        // 如果已经是显示状态，则隐藏并移除.QA-actived类
                        content.style.display = "none";
                        this.classList.remove("QA-actived");
                    }
                });
            });
        

    },
    methods: {
        formateTime(time) {
            return moment.unix(new Date(time)).format("YYYY-MM-DD")
        },
    }
}
</script>

<style>
    body{
        font-family: "Inter", "Noto Sans", "Noto Sans SC", sans-serif !important;
    }
</style>
<style scoped>
@import url("../../assets/css/forex/rem.css");
@import url("../../assets/css/forex/common.css");
@import url("../../assets/css/forex/forex-tool.css");

.forex-index {
    font-family: "Inter", "Noto Sans", "Noto Sans SC", sans-serif !important;
}
</style>